'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

require('babel-polyfill');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRouterScroll = require('react-router-scroll');

var _create = require('./redux/create');

var _create2 = _interopRequireDefault(_create);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

var _Logs = require('./helpers/Logs');

var _Logs2 = _interopRequireDefault(_Logs);

var _SegmentLogs = require('./helpers/SegmentLogs');

var _log = require('./redux/modules/log');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
 */
var DevTools = require('./containers/DevTools/DevTools');

var dest = document.getElementById('content');
var store = (0, _create2.default)(_reactRouter.browserHistory, window.__data);

var finalState = store.getState();
_config2.default.apiProxyUrl = finalState.appInfo.apiProxyUrl;
_config2.default.universalLoginApiUrl = finalState.appInfo.universalLoginApiUrl;
_config2.default.captchaSiteKey = finalState.appInfo.captchaSiteKey;
_config2.default.envPrefix = finalState.appInfo.envPrefix;
_config2.default.fbAppId = finalState.appInfo.fbAppId;
_config2.default.isSecured = finalState.appInfo.isSecured;
_config2.default.segmentKey = finalState.appInfo.segmentKey;
_config2.default.maintenance = finalState.appInfo.maintenance;

if (_config2.default.isDev) {
  console.log('Store = ' + _config2.default.apiProxyUrl);
}

// Set the language for the captcha
window.recaptchaOptions = {
  lang: store.getState().auth.lang
};

(0, _SegmentLogs.initSegment)();

// Save the initial source for logs
(0, _log.saveLogNavigation)((0, _Logs.getLogNameByPathname)(window.location.pathname), new Date().getTime(), store);

var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);

var component = _react2.default.createElement(
  _reactRouter.Router,
  {
    render: function render(props) {
      (0, _reactRouter.applyRouterMiddleware)((0, _reactRouterScroll.useScroll)());
      return _react2.default.createElement(_reduxAsyncConnect.ReduxAsyncConnect, (0, _extends3.default)({}, props, { helpers: {}, filter: function filter(item) {
          return !item.deferred;
        } }));
    },
    onUpdate: function onUpdate() {
      window.scrollTo(0, 0);
    },
    history: history
  },
  (0, _routes2.default)(store)
);

_reactDom2.default.render(_react2.default.createElement(
  _reactRedux.Provider,
  { store: store, key: 'provider' },
  component
), dest);

if (process.env.NODE_ENV !== 'production') {
  window.React = _react2.default; // enable debugger

  if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-react-checksum']) {
    console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.');
  }
}

history.listen(function (location) {
  (0, _Logs2.default)(store.getState().log.src, (0, _Logs.getLogNameByPathname)(location.pathname), store.getState().log, store.getState().auth, store.getState().appInfo, store);
});

var state = store.getState();
(0, _Logs2.default)(document.referrer, (0, _Logs.getLogNameByPathname)(document.location.pathname), state.log, state.auth, state.appInfo, store);

if (__DEVTOOLS__ && !window.devToolsExtension) {
  _reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: store, key: 'provider' },
    _react2.default.createElement(
      'div',
      null,
      component,
      _react2.default.createElement(DevTools, null)
    )
  ), dest);
}


//////////////////
// WEBPACK FOOTER
// ./src/client.js
// module id = 1939
// module chunks = 0